<template>
  <portal to="iqos-backdrop-alpha" v-if="shown">
    <div class="white-tooltip-backdrop" @click="$emit('close')"></div>
    <div
      class="white-tooltip-menu shadow-2 positioned"
      :style="{
        width: `${width}px`,
      }"
    >
      <div class="tooltip-header">
        <div class="qrw-heading-xs bold v1-grey-10-color w-100">
          {{ title }}
        </div>
        <BaseButton
          size="sm"
          icon="x"
          @click="$emit('close')"
          color="v1-grey-8"
        />
      </div>

      <div class="tooltip-body">
        <slot />
      </div>
    </div>
  </portal>
</template>

<script>
export default {
  props: {
    title: String,
    width: {
      type: Number,
      default: 320,
    },
    shown: {
      type: Boolean,
      default: true
    }
  },
};
</script>

<style scoped>
.white-tooltip-menu {
  display: flex;
  flex-direction: column;
  border-radius: 8px;
  overflow: hidden;
  background: var(--v1-grey-1-color);
}

.white-tooltip-menu.positioned {
  position: absolute;
  z-index: 10;
  top: 52px;
  right: 40px;
}

.tooltip-header {
  display: flex;
  flex-direction: row;
  column-gap: 8px;
  background: var(--v1-grey-2-color);
  padding: 12px 12px 12px 16px;
  align-content: center;
  align-items: center;
}

.white-tooltip-backdrop {
  position: fixed;
  width: 100vw;
  height: 100vh;
  z-index: 9;
  top: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.24);
}
</style>
